// extracted by mini-css-extract-plugin
export default {"container":"O1-z"};